import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconWarning = ({ id, color, width = 49, style, ...restProps }: IProps) => {
  const viewBoxWidth = 16;
  const viewBoxHeight = 16;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}
      fill="none">
      <path
        d="M8 11.2998C8.17943 11.2998 8.32995 11.239 8.45154 11.1174C8.57313 10.9958 8.63372 10.8455 8.6333 10.6665C8.63287 10.4875 8.57208 10.3372 8.45091 10.2156C8.32974 10.094 8.17943 10.0332 8 10.0332C7.82056 10.0332 7.67026 10.094 7.54909 10.2156C7.42792 10.3372 7.36712 10.4875 7.3667 10.6665C7.36628 10.8455 7.42708 10.996 7.54909 11.118C7.67111 11.24 7.82141 11.3006 8 11.2998ZM8 9.39988C8.17943 9.39988 8.32995 9.33909 8.45154 9.2175C8.57313 9.0959 8.63372 8.9456 8.6333 8.76659V6.8667C8.6333 6.68726 8.5725 6.53696 8.45091 6.41579C8.32931 6.29462 8.17901 6.23382 8 6.2334C7.82099 6.23298 7.67068 6.29378 7.54909 6.41579C7.4275 6.53781 7.3667 6.68811 7.3667 6.8667V8.76659C7.3667 8.94602 7.4275 9.09654 7.54909 9.21813C7.67068 9.33972 7.82099 9.40031 8 9.39988Z"
        fill={iconColor}
      />
      <path
        d="M1.80947 13.1129C1.90446 13.1707 2.01001 13.1996 2.12612 13.1996H13.8738C13.9903 13.2005 14.0959 13.1716 14.1904 13.1129C14.285 13.0542 14.3589 12.9776 14.4121 12.883C14.4653 12.7884 14.4944 12.6856 14.4995 12.5746C14.5045 12.4635 14.4754 12.3552 14.4121 12.2497L8.55408 2.11694C8.4916 2.01139 8.4099 1.93223 8.309 1.87946C8.20809 1.82668 8.10507 1.80029 7.99995 1.80029C7.89482 1.80029 7.79201 1.82668 7.69153 1.87946C7.59105 1.93223 7.50914 2.01139 7.44581 2.11694L1.58782 12.2497C1.52491 12.3552 1.49599 12.4633 1.50105 12.5739C1.50612 12.6846 1.53504 12.7876 1.58782 12.883C1.64059 12.9784 1.71448 13.055 1.80947 13.1129Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconWarning;
